/** For in-app download prompts (Play vs App Store). */
export type MobileAppPlatform = "android" | "ios" | "other";

const STORAGE_KEY = "veshjeperty_app_download_bar_dismissed";

/**
 * Detect mobile device and coarse OS for store deep links.
 * Returns null when not a handheld-style UA (desktop / bots).
 */
export function getMobileAppPlatform(): MobileAppPlatform | null {
    if (typeof navigator === "undefined") return null;
    const ua = navigator.userAgent || "";
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        ua
    );
    if (!isMobile) return null;
    if (/android/i.test(ua)) return "android";
    if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
    return "other";
}

export function isAppDownloadBarDismissed(): boolean {
    try {
        return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        return false;
    }
}

export function setAppDownloadBarDismissed(): void {
    try {
        localStorage.setItem(STORAGE_KEY, "1");
    } catch {
        /* ignore */
    }
}
